import styled from '@emotion/styled';
import Button from '@mui/material/Button';

import { useFeedbackDialogStore } from './use-feedback-dialog-store';

import type { FunctionComponent } from 'react';

type ActionButtonsProps = {
    readonly canSubmit: boolean;
    readonly onCancel: () => void;
    readonly onSubmit: () => void;
};

const ButtonsContainer = styled.div({
    display: 'flex',
    gap: '0.75rem',
    justifyContent: 'flex-end',
    width: '100%',
});

const CancelButton = styled(Button)({
    background: '#fbfbff',
    border: '0.0625rem solid #e7e7e7',
    borderRadius: '0.625rem',
    color: '#505052',
    fontFamily: 'FT Regola Neue',
    fontSize: '0.875rem',
    fontWeight: 500,
    height: '2.25rem',
    lineHeight: '1.25rem',
    padding: '0.5rem 1.5rem',
    textTransform: 'none',
});

const SubmitButton = styled(Button)({
    ':disabled': {
        backgroundColor: '#B1B4B9',
        color: '#FBFBFF',
    },
    background: '#040f16',
    borderRadius: '0.625rem',
    color: '#fbfbff',
    fontFamily: 'FT Regola Neue',
    fontSize: '0.875rem',
    fontWeight: 500,
    height: '2.25rem',
    lineHeight: '1.25rem',
    padding: '0.5rem 1.5rem',
    textTransform: 'none',
});

export const ActionButtons: FunctionComponent<ActionButtonsProps> = ({ canSubmit, onCancel, onSubmit }) => {
    const submitFeedbackLabel = useFeedbackDialogStore((state) => state.submitFeedbackLabel);
    const cancelButtonLabel = useFeedbackDialogStore((state) => state.cancelButtonLabel);

    return (
        <ButtonsContainer>
            <CancelButton onClick={onCancel}>{cancelButtonLabel}</CancelButton>
            <SubmitButton disabled={canSubmit === false} onClick={onSubmit}>
                {submitFeedbackLabel}
            </SubmitButton>
        </ButtonsContainer>
    );
};
